import { useLocationBasedExtraServices } from "@lib/logic";
import { LocationType, useOverridableFeatureFlags } from "@lib/store";
import { ExtraServicesListItem } from "@molecules";
import { FlexCol, H2 } from "@quarks";
import { cn } from "@utils";
import { useTranslation } from "react-i18next";

type Props = {
  buildingId: string;
  locationType: LocationType;
  locationName: string;
};

export const LocationBasedServices = ({ buildingId, locationType, locationName }: Props) => {
  const { t } = useTranslation();
  const { ExtrasFeature } = useOverridableFeatureFlags();

  const { highlightedServices, highlightedServicesCount } = useLocationBasedExtraServices(buildingId, locationType);

  if (!ExtrasFeature || highlightedServicesCount === 0) return <></>;

  return (
    <FlexCol gap={16}>
      <H2 as="h3">{t("translation:Services")}</H2>
      <div className={cn("gap-6 w-full grid grid-cols-1")}>
        {highlightedServices.map(service => {
          return (
            <ExtraServicesListItem
              key={service.id}
              service={service}
              titleType="P"
              meetingId={undefined}
              selectedDate={undefined}
              locationName={locationName}
            />
          );
        })}
      </div>
    </FlexCol>
  );
};
